import {
  Banknote,
  Bot,
  CalendarClock,
  ClipboardList,
  Headphones,
  HeartHandshake,
  PhoneOutgoing,
  Scale,
  Star,
  UserRoundSearch,
  type LucideIcon,
} from "lucide-react";

// Admin templates carry an optional lucide icon name and a category; resolve
// either to a component so the quickstart cards always have an icon.
const ICON_BY_NAME: Record<string, LucideIcon> = {
  headphones: Headphones,
  "user-round-search": UserRoundSearch,
  "calendar-clock": CalendarClock,
  "clipboard-list": ClipboardList,
  "heart-handshake": HeartHandshake,
  star: Star,
  scale: Scale,
  banknote: Banknote,
  "phone-outgoing": PhoneOutgoing,
  bot: Bot,
};

const ICON_BY_CATEGORY: Record<string, LucideIcon> = {
  sales: UserRoundSearch,
  healthcare: HeartHandshake,
  finance: Banknote,
  legal: Scale,
  general: Headphones,
  support: Headphones,
};

export function templateIcon(icon: string, category: string): LucideIcon {
  return (
    ICON_BY_NAME[icon.trim().toLowerCase()] ??
    ICON_BY_CATEGORY[category.trim().toLowerCase()] ??
    Bot
  );
}
